<template>
  <div>
    <c-search-box @enter="getList">
      <template slot="search">
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-plant type="search" name="plantCd" v-model="searchParam.plantCd" />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-datepicker
            :range="true"
            defaultStart="-6M"
            defaultEnd="6M"
            label="(기간)조치완료일"
            name="actionCompleteDates"
            v-model="searchParam.actionCompleteDates"
          />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-select
            codeGroupCd="IBM_TASK_TYPE_CD"
            type="search"
            itemText="codeName"
            itemValue="code"
            name="ibmTaskTypeCd"
            label="업무"
            v-model="searchParam.ibmTaskTypeCd"
          ></c-select>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-select
            stepperGrpCd="IBM_SUPPLE_STEP_CD"
            type="search"
            itemText="stepperMstNm"
            itemValue="stepperMstCd"
            name="ibmSuppleStepCd"
            label="보완진행단계"
            v-model="searchParam.ibmSuppleStepCd"
          ></c-select>
        </div>
        <div class="col-xs-6 col-sm-6 col-md-3 col-lg-3 col-xl-3">
          <!-- 요청부서 -->
          <c-dept 
            :isFirstValue="false"
            type="search" 
            label="요청부서" 
            name="improveRequestDeptCd" 
            v-model="searchParam.improveRequestDeptCd" />
        </div>
        <div class="col-xs-6 col-sm-6 col-md-3 col-lg-3 col-xl-3">
          <!-- 보완부서 -->
          <c-dept 
            type="search" 
            label="보완부서" 
            name="actionDeptCd" 
            v-model="searchParam.actionDeptCd" />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-checkbox
            :isFlag="true"
            falseLabel="All"
            label="보완필요 업무 확인"
            name="suppleFlag"
            v-model="searchParam.suppleFlag"
          />
        </div>
      </template>
    </c-search-box>
    <q-table
      grid
      title=""
      :data="grid.data"
      :columns="grid.columns"
      hide-header
      hide-bottom
      :rows-per-page-options="[0]"
      virtual-scroll
    >
      <template v-slot:top-right>
        <!-- <q-btn-group outline >
          <c-btn label="등록" :editable="editable" icon="add" @btnClicked="addEtcImpr" />
        </q-btn-group> -->
      </template>
      <template v-slot:item="props">
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-3">
          <q-card class="mobileTableCardLayer" @click="linkClick(props.row)">
            <q-card-section horizontal class="bg-grey-2">
              <q-card-section class="q-pt-xs">
                <div class="text-grid-title q-mt-sm q-mb-xs">[{{ props.row.ibmTaskTypeName }}] {{ props.row.ibmTitle }}</div>
              </q-card-section>
            </q-card-section>
            <q-card-section class="grid-card-etc">
              <template v-if="props.row.suppleFlag==='Y'">
                <div class="text-grid-etc-title">
                  보완완료 요청일 :
                </div>
                <div class="text-grid-etc">
                  {{ props.row.suppleScheduleDate }}
                </div>
              </template>
              <div :class="['text-grid-etc', getColorStatus(props.row.ibmSuppleStepCd)]">
                {{ props.row.ibmSuppleStepName || props.row.suppleFlagName }}
              </div>
            </q-card-section>
          </q-card>
        </div>
      </template>
    </q-table>
    <div class="col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-3" v-if="grid.data.length === 0">
      <q-card class="mobileTableCardLayer">
        <q-card-section horizontal class="bg-grey-2 text-center">
          <q-card-section class="q-pt-xs">
            <div class="text-grid-title q-mt-sm q-mb-xs">데이터가 존재하지 않습니다.</div>
          </q-card-section>
        </q-card-section>
      </q-card>
    </div>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';
export default {
  name: 'imprSupple',
  data() {
    return {
      searchParam: {
        plantCd: null,
        actionCompleteDates: [],
        ibmClassCd: 'IC00000001',
        ibmTaskTypeCd: null,
        ibmSuppleStepCd: null,
        improveRequestDeptCd: '',
        actionDeptCd: '',
        suppleFlag: 'N',
        actionFlag: 'D',
      },
      grid: {
        columns: [
          {
            name: 'ibmTaskTypeName',
            field: 'ibmTaskTypeName',
            label: '업무',
            align: 'center',
            style: 'width:90px',
            sortable: true
          },
          {
            name: 'ibmTitle',
            field: 'ibmTitle',
            label: '제목',
            align: 'left',
            style: 'width:250px',
            type: 'link',
            sortable: true,
          },
          {
            name: 'suppleFlagName',
            field: 'suppleFlagName',
            label: '적합/보완',
            align: 'center',
            style: 'width:80px',
            sortable: true
          },
          {
            name: 'ibmSuppleStepName',
            field: 'ibmSuppleStepName',
            label: '보완진행단계',
            align: 'center',
            style: 'width:100px',
            sortable: true
          },
          {
            name: 'suppleScheduleDate',
            field: 'suppleScheduleDate',
            label: '보완완료 요청일',
            align: 'center',
            style: 'width:170px',
            sortable: true,
          },
        ],
        data: [],
      },
      editable: true,
      listUrl: '',
      popupOptions: {
        isFull: true,
        target: null,
        title: '',
        visible: false,
        top: '',
        param: {},
        closeCallback: null,
      },
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.listUrl = selectConfig.sop.ibm.improve.supple.list.url
      // code setting
      // list setting
      this.getList();
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      },);
    },
    getColorStatus(cd) {
      var cls = '';
      switch(cd) {
        case 'ISS0000001': // 보완요청
          cls = 'text-primary';
          break;
        case 'ISS0000005': // 보완중
          cls = 'text-orange-10';
          break;
        case 'ISS0000010': // 검토중
          cls = 'text-blue-grey';
          break;
        case 'ISS0000015': // 보완완료
          cls = 'text-positive';
          break;
        default:
          cls = 'text-light-green';
          break;
      }
      return cls;
    },
    /* eslint-disable no-unused-vars */
    linkClick(row, col, index) {
      this.popupOptions.title = '개선 상세'; // 개선 상세
      this.popupOptions.param = {
        sopImprovementId: row.sopImprovementId,
      };
      this.popupOptions.target = () => import(`${'./imprDetail.vue'}`);
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closePopup;
    },
    closePopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      this.getList();
    },
  }
};
</script>
